var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "vks-track", attrs: { "aria-label": _vm.section.label } },
    [
      _c("header", { staticClass: "vks-track-head" }, [
        _c("h3", { staticClass: "vks-track-title" }, [
          _vm._v(_vm._s(_vm.section.label)),
        ]),
      ]),
      _c("div", { staticClass: "vks-track-body", style: _vm.trackBodyStyle }, [
        _c("div", { staticClass: "vks-track-placeholder" }, [
          _c("span", { staticClass: "vks-track-placeholder-mark" }, [
            _vm._v(_vm._s(_vm.section.shortLabel)),
          ]),
          _c("p", { staticClass: "vks-track-placeholder-text" }, [
            _vm._v(
              " " + _vm._s(_vm.section.label) + " visualizer will render here. "
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }